import React, { useState, useContext, useEffect } from "react";
import "react-toastify/dist/ReactToastify.css";
import "../App.css";
import "./component.css";
import { ResourceTab } from "./ResourceTab";
import { State } from "../context/State";
import { parseFeatureInput, determineInputCategory } from "./util";
import Library from "./Library";

const defaultDetected = ["-", "gray"];

export const LayerInput = () => {
  const { view, setView, addLayer, setShowLibrary, showLibrary } = useContext(
    State
  );
  const [textArea, setTextArea] = useState("");
  // const [tab, setTab] = useState("raw");

  const [[detectedInput, detectedColor], setDetectedInput] = useState(
    defaultDetected
  );
  const [coordsAreXY, setCoordsAreXY] = useState(false);
  const [combinePoints, setCombinePoints] = useState(true);

  const submit = ({ e }) => {
    // Do validation
    if (textArea.length > 0) {
      parseFeatureInput({
        view,
        setView,
        textArea,
        addLayer,
        coordsAreXY,
        combinePoints
      });
    }
    e.preventDefault();
  };

  useEffect(() => {
    if (textArea.length > 0) determineInputCategory(textArea, setDetectedInput);
    else setDetectedInput(defaultDetected);
  }, [textArea]);

  const inputIsCoords = detectedInput === "Coordinates";

  const coordsOrientationChange = e => {
    const value = e.target.value;
    setCoordsAreXY(value);
  };

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <div></div>
        <button
          className="link-button"
          onClick={() => setShowLibrary(!showLibrary)}
        >
          Add Layer From Library <span style={{ fontSize: "1.4em" }}>+</span>
        </button>
      </div>
      <form
        onSubmit={e =>
          submit({
            addLayer,
            e
          })
        }
      >
        <div className="input-box">
          <textarea
            placeholder={"Paste WKT, GeoJSON, or coordinates"}
            style={{
              width: "100%",
              height: "100%",
              resize: "none",
              border: "solid 1px rgb(186, 186, 186)"
            }}
            value={textArea}
            onChange={e => setTextArea(e.target.value)}
          ></textarea>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div>
              <input
                style={{
                  marginRight: 10,
                  border: "solid 1px rgb(186, 186, 186)"
                }}
                type="submit"
                value={"Add Layer"}
              />
              <div
                style={{
                  color: detectedColor,
                  fontSize: "90%",
                  marginRight: 10,
                  display: "inline-block"
                }}
              >
                {detectedInput}
              </div>
            </div>
            <div>
              {inputIsCoords && (
                // Coords orientation
                <div
                  style={{
                    flex: 1,
                    fontSize: "90%",
                    display: "flex"
                  }}
                >
                  {/* Combine */}
                  <div style={{ float: "right", marginRight: 5 }}>
                    <div style={{ display: "inline-block" }}>Single layer</div>
                    <input
                      style={{ display: "inline-block" }}
                      //   name="isGoing"
                      type="checkbox"
                      checked={combinePoints}
                      onChange={() => setCombinePoints(!combinePoints)}
                    />
                  </div>

                  <div
                    style={{
                      display: "inline-block",
                      float: "right"
                    }}
                  >
                    <select
                      value={coordsAreXY}
                      onChange={coordsOrientationChange}
                    >
                      <option value={false}>Lat,Lon / Y,X</option>
                      <option value={true}>Lon,Lat / X,Y</option>
                    </select>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};
